import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';
import ShippingIcon from '@tradera/blueprint/theme/icons2/shipping.svg?jsx';
import {
    selectAvailableShippingCountries,
    selectShippingCountry,
    selectIsLoadingAvailableShippingCountries,
    selectHasLoadedAvailableShippingCountries
} from 'tradera-state/shipping-region/selectors';
import {
    updateShippingRegion,
    getAvailableShippingCountries
} from 'tradera-state/shipping-region/actions';
import Spinner from 'components/spinner/spinner';
import { ShippingCountrySelectDropdown } from './shipping-country-select-dropdown';

export const ShippingCountrySelect = ({
    getAvailableShippingCountries,
    shippingCountry,
    shippingCountries,
    updateShippingRegion,
    showShippingCountries,
    isLoadingAvailableShippingCountries,
    onShippingCountrySelected
}) => {
    const { t } = useTranslator();
    getAvailableShippingCountries();

    return (
        <div className="p-2">
            <span className="d-flex align-items-center mb-2">
                <ShippingIcon className="icon icon-md" />
                <strong className="ml-2">
                    {t('siteHeader_shippingCountry')}
                </strong>
            </span>
            <div className="localization-shipping-country">
                {isLoadingAvailableShippingCountries && (
                    <div className="w-100 d-flex justify-content-center">
                        <Spinner className="position-relative mt-4 mb-5" />
                    </div>
                )}
                {showShippingCountries && (
                    <ShippingCountrySelectDropdown
                        shippingCountries={shippingCountries}
                        selectedShippingCountry={shippingCountry}
                        onSelect={countryCodeIso2 => {
                            onShippingCountrySelected(countryCodeIso2);
                            updateShippingRegion(countryCodeIso2);
                        }}
                    />
                )}
            </div>
        </div>
    );
};

ShippingCountrySelect.propTypes = {
    shippingCountries: PropTypes.arrayOf(PropTypes.string),
    shippingCountry: PropTypes.object,
    updateShippingRegion: PropTypes.func
};

const mapStateToProps = state => ({
    shippingCountry: selectShippingCountry(state),
    shippingCountries: selectAvailableShippingCountries(state),
    isLoadingAvailableShippingCountries: selectIsLoadingAvailableShippingCountries(
        state
    ),
    showShippingCountries:
        selectHasLoadedAvailableShippingCountries(state) &&
        !selectIsLoadingAvailableShippingCountries(state)
});

const mapDispatchToProps = {
    updateShippingRegion,
    getAvailableShippingCountries
};

export const ConnectedShippingCountrySelect = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShippingCountrySelect);
